import {BaseWebComponentDataProvider} from "../../../framework/BaseWebComponentDataProvider";
import {ConsoleRequest, DataProviderType} from "../../../utils/request";
import {NewIntegration} from "../../saveIntegration/types";

export class IntegrationsMarketplaceAppContainerNirvanaDataProvider extends BaseWebComponentDataProvider {
  public async createRecords(records: NewIntegration[]): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'IntegrationInstances',
      method: 'createRecords',
      payload: {
        records: records,
      },
    });
  }

  public async updateRecords(records: NewIntegration[]): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'IntegrationInstances',
      method: 'updateRecords',
      payload: {
        records: records,
      },
    });
  }

  getDataForView() {

  }
}
